// extracted by mini-css-extract-plugin
export default {"recordLinkageRow":"recordLinkageRow---Ay5_s","recordLinkageRowCell":"recordLinkageRowCell---Ch3Gs"};